// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { CategoryFacet, CategoryFacetState, CategoryFacetValue } from "@coveo/headless/commerce";
import { productListCategoryFiltersStyles } from "@insite/content-library/Widgets/ProductList/ProductListCategoryFilters";
import MyBranchState from "@NA/Store/Data/ADIMyBranchState";
import CoveoCategoryFacetAccordionContainer from "@NA/Widgets/Coveo/Facet/CoveoCategoryFacetAccordionContainer";
import React, { useEffect, useState } from "react";

interface CoveoRegularFacetProps {
    facet: CategoryFacet;
    myBranchDetails: MyBranchState;
    showMobileFilter: boolean;
    isAuthenticated: boolean;
}

const CoveoCategoryFacet: React.FC<CoveoRegularFacetProps> = ({
    facet,
    myBranchDetails,
    showMobileFilter,
    isAuthenticated,
}) => {

    const [facetState, setFacetState] = useState<CategoryFacetState>(facet.state);

    useEffect(() => facet.subscribe(() => setFacetState(facet.state)), [facet]);

    const onChangeFacet = (value: CategoryFacetValue) => {
        facet.toggleSelect(value);
    };

    return (
        <>
            {isAuthenticated && (
                <CoveoCategoryFacetAccordionContainer
                    onChangeFacet={onChangeFacet}
                    expandByDefault={!showMobileFilter}
                    extendedStyles={productListCategoryFiltersStyles}
                    myBranchDetails={myBranchDetails}
                    isAuthenticated={isAuthenticated}
                    canShowMoreValues={facetState.canShowMoreValues ?? false}
                    facetState={facetState}
                    facet={facet}
                />
            )}
        </>
    );
};

export default CoveoCategoryFacet;
